"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopOverMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var PopOverMenu = function (_a) {
    var buttonProps = _a.buttonProps, children = _a.children, options = _a.options, closeMenuOnItemClick = _a.closeMenuOnItemClick, rest = __rest(_a, ["buttonProps", "children", "options", "closeMenuOnItemClick"]);
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var classes = (0, styles_1.useStyles)();
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };
    var handleClose = function (event) {
        setAnchorEl(null);
        event.stopPropagation();
    };
    var OptionalTooltip = react_1.default.memo(function (_a) {
        var title = _a.title, content = _a.children;
        return title ? (0, jsx_runtime_1.jsx)(core_1.Tooltip, __assign({ title: title }, { children: content })) : content;
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ "aria-controls": "customized-menu" }, buttonProps, { "aria-label": "popover-menu", onClick: handleClick }, { children: children })), (0, jsx_runtime_1.jsx)(core_1.Menu, __assign({ className: classes.paper, getContentAnchorEl: null, anchorEl: anchorEl, anchorOrigin: { horizontal: 'left', vertical: 'bottom' }, transformOrigin: { horizontal: 'center', vertical: 'top' }, open: Boolean(anchorEl), onClose: handleClose }, rest, { children: (0, jsx_runtime_1.jsx)(core_1.MenuList, { children: options.map(function (_a) {
                        var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, title = _a.title, disabled = _a.disabled, option = __rest(_a, ["onClick", "title", "disabled"]);
                        return ((0, jsx_runtime_1.jsx)(OptionalTooltip, __assign({ title: title }, { children: (0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ disabled: disabled, className: classes.menuItem, onClick: function (event) {
                                    var _a;
                                    event.stopPropagation();
                                    (_a = event.nativeEvent) === null || _a === void 0 ? void 0 : _a.stopImmediatePropagation();
                                    // need to check for disabled here
                                    if (!disabled) {
                                        onClick(event);
                                        if (closeMenuOnItemClick)
                                            setAnchorEl(null);
                                    }
                                } }, { children: [(0, jsx_runtime_1.jsx)(core_1.ListItemIcon, __assign({ className: classes.itemIcon }, option.icon)), (0, jsx_runtime_1.jsx)(core_1.ListItemText, __assign({}, option.item))] })) }), option.item.id));
                    }) }) }))] }));
};
exports.PopOverMenu = PopOverMenu;
